import type { ObjectToArray_F } from './types';

export const objectToArray: ObjectToArray_F = obj => {
  return Object.values(obj);
};
